import React , {Component} from 'react';
import './users.css';
import {Table, Nav} from 'react-bootstrap'
import Edit from '../../image/edit.svg';
import Delete from '../../image/delete.svg';
import{Link } from 'react-router-dom';
import Usersiconimg from '../../image/users.svg';

class Users extends Component {
  constructor() {
    super();
    this.state = {
      list: null
    };
  }

  async ge(){
    const res = await fetch('./db.json');
    const data = await res.json();
    this.setState({
      list:data
    })
  }
  
  componentDidMount() {
    this.ge()
  }

  
  render() {
    return (
      <div className='container usermain'>
        <div className="row">
          <div className="col-1">
            <div className="userlogo">
              <img src={Usersiconimg} alt="" className="userlogoicon" />
            </div>
          </div>

          <div className="col-11">
          <div className="usersearchsec">
          <span className="usertitle">Users</span>
          <form action="">
            <input type="search" placeholder="Search" className="usersearch" />
          </form>
        </div>
        <Table responsive className="userstable">
          {Array.from({ length: 1 }).map((_, index) => (
            <thead className='userstitle'>
              <td style={td}>SL</td>

              <td style={td}>Name</td>

              <td style={td}>Company</td>

              <td style={td}>Role</td>

              <td style={td}>Email</td>

              <td style={td}>Mobile</td>

              <td style={td}>Actions</td>
            </thead>
          ))}
        </Table>

        {this.state.list ? (
          <div>
            {this.state.list.map((item, i) => (
              <Table responsive className="d-block ussersitems">
                {Array.from({ length: 1 }).map((_, index) => (
                  <tbody className="userstitle">

                    <td style={td}>{i}</td>

                    <td style={td}>{item.name}</td>

                    <td style={td}>{item.company}</td>

                    <td style={td}>{item.role}</td>

                    <td style={td}>{item.email}</td>

                    <td style={td}>{item.mobile}</td>

                    <td style={td}>
                      <Nav.Link className="usersiconupdate">
                        <Link to={"/update/"+item.id} className="usersedit">
                          <img src={Edit} alt="" />
                        </Link>
                        <Link to="/update" className="usersdelete">
                          <img src={Delete} alt="" />
                        </Link>
                      </Nav.Link>

                    </td>
                  </tbody>
                ))}
              </Table>
            ))}
          </div>
        ) : (
          <p>please wait....</p>
        )}
          </div>
        </div>
      </div>
    );
  }
}
const td = {
  textAlign: "center",
  display: "grid",
  alignContent: "center",
  margin: "10px 0px",
};

export default Users;